import { getValiCode } from '@/mock/mock';
import OSS from 'ali-oss';
class ApplyMethods {
  constructor (props) {
    this.vue = props
  }
  inputBlur () {
    setTimeout(() => {
      if (
        document.activeElement.tagName === 'INPUT' ||
        document.activeElement.tagName === 'TEXTAREA'
      ) {
        return;
      }
      let result = 'pc';
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        // 判断iPhone|iPad|iPod|iOS
        result = 'ios';
      } else if (/(Android)/i.test(navigator.userAgent)) {
        // 判断Android
        result = 'android';
      }
      if (result === 'ios') {
        document.activeElement.scrollIntoViewIfNeeded(true);
        // IOS 键盘收起后操作
        // 微信浏览器版本6.7.4+IOS12会出现键盘收起后，视图被顶上去了没有下来
        var wechatInfo = window.navigator.userAgent.match(
          /MicroMessenger\/([\d.]+)/i
        );
        if (!wechatInfo) {
          return;
        }
        var wechatVersion = wechatInfo[1];
        var version = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);

        if (+wechatVersion.replace(/\./g, '') >= 674 && +version[1] >= 12) {
          console.log(
            Math.max(
              document.body.clientHeight,
              document.documentElement.clientHeight
            )
          );
          window.scrollTo(
            0,
            Math.max(
              document.body.clientHeight,
              document.documentElement.clientHeight
            )
          );
        }
      }
    }, 100);
  }
  async getValiCode () {
    if (this.isGettingCode || this.secondHandel) {
      return;
    }
    this.isGettingCode = true;
    let errorMsg = '';
    if (this.phoneNumber === '') {
      errorMsg = '手机号不能为空';
    } else if (this.phoneError !== '') {
      errorMsg = '手机号格式错误';
    }
    if (errorMsg) {
      this.toast.show(errorMsg, !1);
      this.isGettingCode = false;
      return;
    }
    getValiCode({
      mobile: this.phoneNumber
    }).then((result) => {
      if (result.data.code === '200' || result.data.code === '304') {
        this.toast.show('发送成功', !0);
        this.secondHandel = setInterval(() => {
          if (this.second > 1) {
            this.second = this.second - 1;
          } else {
            clearInterval(this.secondHandel);
            this.secondHandel = null;
            this.second = 60;
          }
        }, 1000);
      } else {
        this.toast.show(result.data.text || '获取失败', !1);
      }
      this.isGettingCode = false;
    });
  }
  wxRedy () {
    this.$wx.ready(() => {
      this.$wx.onMenuShareTimeline(this.shareTimelineData);
      this.$wx.onMenuShareAppMessage(this.shareAppMessageData);
      this.$wx.hideMenuItems({
        menuList: ['menuItem:copyUrl',
          'menuItem:share:qq',
          'menuItem:share:weiboApp',
          'menuItem:share:facebook',
          'menuItem:share:QZone',
          'menuItem:originPage',
          'menuItem:openWithQQBrowser',
          'menuItem:openWithSafari',
          'menuItem:share:email'
        ]
      });
      this.$wx.error((res) => {
        console.log(res)
      });
    });
  }
  createFileName () {
    function S4 () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return `${S4()}${S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`;
  }
  compress (fileObj, cb, dpr) {
    // 图片压缩  fileObj上传文件的对象
    const reader = new FileReader();
    reader.readAsDataURL(fileObj);
    reader.onload = function (e) {
      const image = new Image(); // 新建一个img标签（还没嵌入DOM节点)
      image.src = e.target.result;
      image.onload = function () {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        const imageWidth = image.width / dpr // 压缩后图片的大小
        const imageHeight = image.height / dpr
        canvas.width = imageWidth;
        canvas.height = imageHeight;
        context.drawImage(image, 0, 0, imageWidth, imageHeight);
        canvas.toBlob((blob) => {
          // 压缩完成
          cb(blob);
        });
      };
    };
  }
  uploadImg (files, dpr = 8) {
    // h5选择图片
    return new Promise((resolve, reject) => {
      this.compress(
        files,
        async (data) => {
          const client = new OSS({
            region: 'oss-cn-qingdao',
            accessKeyId: 'LTAICrDd0avLrBqu',
            accessKeySecret: 'fry0NyshnJqfFbI0JAcuk1ew7NZKe0',
            bucket: 'app-ccchong-com'
          });
          try {
            const result = await client.put(this.createFileName() + '.png', data);
            resolve(`https://app-cdn.starcharge.com/${result.name}`)
          } catch (e) {
            resolve('')
          }
        },
        dpr
      );
    })
  }
}

export default ApplyMethods



// WEBPACK FOOTER //
// ./src/starcharge/utils/applyMethods.js